import { axios } from '@/utils/request'
import qs from 'qs'

let moduleName = 'unit'
let unitTypeEnum = {
  AREA: 1,
  CURRENCY: 2,
  CYCLE: 3,
  RENT: 4
}
export function selectAll() {
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
  })
}

export function selectByType(parameter) {
  console.log('type:', parameter)
  return axios({
    url: `/ws/${moduleName}/selectByType/${parameter}`,
    method: 'get'
  })
}
export function selectUseCompanyIdByType(type,parameter) {
  console.log('type:', type,parameter)
  return axios({
    url: `/ws/${moduleName}/selectUseCompanyIdByType/${type}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function queryCompanyAndType(companyId,type) {
  return axios({
    url: `/ws/${moduleName}/queryCompanyAndType/${companyId}/${type}`,
    method: 'get',
  })
}


export function insert(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data: parameter
  })
}

export function update(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data: parameter
  })
}



export default {
  selectAll,
  selectByType,
  selectUseCompanyIdByType,
  update,
  queryCompanyAndType,
  save: insert,
  unitTypeEnum
}